import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-10 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-primary-600 font-medium mb-4">
                {appData.subtitle}
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                {appData.description}
              </p>

              <div className="grid grid-cols-2 gap-3 mb-8">
                {appData.features.map((feat) => (
                  <div key={feat.text} className="flex items-center gap-2 text-sm text-foreground-600">
                    <div className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${feat.icon} text-xs text-accent-600`}></i>
                    </div>
                    <span className="whitespace-nowrap">{feat.text}</span>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="px-6 py-2.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill mr-2"></i>iOS 版
                </a>
                <a
                  href="#app"
                  className="px-6 py-2.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill mr-2"></i>Android 版
                </a>
              </div>
            </div>

            <div className="flex-1 p-6 md:p-10 flex justify-center">
              <div className="w-56 h-80 rounded-2xl bg-background-200 overflow-hidden border-4 border-background-300">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20interface%20mockup%20for%20video%20streaming%20platform%2C%20warm%20color%20scheme%2C%20clean%20minimal%20UI%20design%2C%20video%20thumbnails%20grid%20layout%2C%20flat%20design%20style%2C%20soft%20lighting%2C%20elegant%20modern%20aesthetic&width=448&height=640&seq=tomato-app-mock&orientation=portrait"
                  alt="番茄视频移动端界面展示"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}